/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountRouteImport } from './routes/account'
import { Route as OrgRouteImport } from './routes/org'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as InviteInvitationIdRouteImport } from './routes/invite.$invitationId'
import { Route as PProjectIdRouteImport } from './routes/p.$projectId'
import { Route as PrototypesIndexRouteImport } from './routes/prototypes/index'
import { Route as PrototypesAgentFirstRouteImport } from './routes/prototypes/agent-first'
import { Route as PrototypesClashMeetingRouteImport } from './routes/prototypes/clash-meeting'
import { Route as PrototypesEvolutionRouteImport } from './routes/prototypes/evolution'
import { Route as PrototypesManagerRouteImport } from './routes/prototypes/manager'
import { Route as PrototypesPricingRouteImport } from './routes/prototypes/pricing'
import { Route as PrototypesQuoteRouteImport } from './routes/prototypes/quote'
import { Route as PrototypesUnderstudyRouteImport } from './routes/prototypes/understudy'
import { Route as TracesIndexRouteImport } from './routes/traces/index'
import { Route as PProjectIdIndexRouteImport } from './routes/p.$projectId/index'
import { Route as PProjectIdBranchRouteImport } from './routes/p.$projectId.$branch'
import { Route as PProjectIdWorkshopRouteImport } from './routes/p.$projectId/workshop'
import { Route as TracesTraceIdIndexRouteImport } from './routes/traces/$traceId/index'
import { Route as PProjectIdBranchIndexRouteImport } from './routes/p.$projectId.$branch.index'
import { Route as PProjectIdBranchExplorerRouteImport } from './routes/p.$projectId.$branch.explorer'
import { Route as TracesChatsChatIdIndexRouteImport } from './routes/traces/chats/$chatId/index'
import { Route as PProjectIdBranchScopeAppIdRouteImport } from './routes/p.$projectId.$branch.$scope.$appId'
import { Route as PProjectIdBranchWorkbenchViewRouteImport } from './routes/p.$projectId.$branch.workbench.$view'
import { Route as PProjectIdBranchExplorerFilesSplatRouteImport } from './routes/p.$projectId.$branch.explorer.files.$'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgRoute = OrgRouteImport.update({
  id: '/org',
  path: '/org',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteInvitationIdRoute = InviteInvitationIdRouteImport.update({
  id: '/invite/$invitationId',
  path: '/invite/$invitationId',
  getParentRoute: () => rootRouteImport,
} as any)
const PProjectIdRoute = PProjectIdRouteImport.update({
  id: '/p/$projectId',
  path: '/p/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypesIndexRoute = PrototypesIndexRouteImport.update({
  id: '/prototypes/',
  path: '/prototypes/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypesAgentFirstRoute = PrototypesAgentFirstRouteImport.update({
  id: '/prototypes/agent-first',
  path: '/prototypes/agent-first',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypesClashMeetingRoute = PrototypesClashMeetingRouteImport.update({
  id: '/prototypes/clash-meeting',
  path: '/prototypes/clash-meeting',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypesEvolutionRoute = PrototypesEvolutionRouteImport.update({
  id: '/prototypes/evolution',
  path: '/prototypes/evolution',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypesManagerRoute = PrototypesManagerRouteImport.update({
  id: '/prototypes/manager',
  path: '/prototypes/manager',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypesPricingRoute = PrototypesPricingRouteImport.update({
  id: '/prototypes/pricing',
  path: '/prototypes/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypesQuoteRoute = PrototypesQuoteRouteImport.update({
  id: '/prototypes/quote',
  path: '/prototypes/quote',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypesUnderstudyRoute = PrototypesUnderstudyRouteImport.update({
  id: '/prototypes/understudy',
  path: '/prototypes/understudy',
  getParentRoute: () => rootRouteImport,
} as any)
const TracesIndexRoute = TracesIndexRouteImport.update({
  id: '/traces/',
  path: '/traces/',
  getParentRoute: () => rootRouteImport,
} as any)
const PProjectIdIndexRoute = PProjectIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PProjectIdRoute,
} as any)
const PProjectIdBranchRoute = PProjectIdBranchRouteImport.update({
  id: '/$branch',
  path: '/$branch',
  getParentRoute: () => PProjectIdRoute,
} as any)
const PProjectIdWorkshopRoute = PProjectIdWorkshopRouteImport.update({
  id: '/workshop',
  path: '/workshop',
  getParentRoute: () => PProjectIdRoute,
} as any)
const TracesTraceIdIndexRoute = TracesTraceIdIndexRouteImport.update({
  id: '/traces/$traceId/',
  path: '/traces/$traceId/',
  getParentRoute: () => rootRouteImport,
} as any)
const PProjectIdBranchIndexRoute = PProjectIdBranchIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PProjectIdBranchRoute,
} as any)
const PProjectIdBranchExplorerRoute =
  PProjectIdBranchExplorerRouteImport.update({
    id: '/explorer',
    path: '/explorer',
    getParentRoute: () => PProjectIdBranchRoute,
  } as any)
const TracesChatsChatIdIndexRoute = TracesChatsChatIdIndexRouteImport.update({
  id: '/traces/chats/$chatId/',
  path: '/traces/chats/$chatId/',
  getParentRoute: () => rootRouteImport,
} as any)
const PProjectIdBranchScopeAppIdRoute =
  PProjectIdBranchScopeAppIdRouteImport.update({
    id: '/$scope/$appId',
    path: '/$scope/$appId',
    getParentRoute: () => PProjectIdBranchRoute,
  } as any)
const PProjectIdBranchWorkbenchViewRoute =
  PProjectIdBranchWorkbenchViewRouteImport.update({
    id: '/workbench/$view',
    path: '/workbench/$view',
    getParentRoute: () => PProjectIdBranchRoute,
  } as any)
const PProjectIdBranchExplorerFilesSplatRoute =
  PProjectIdBranchExplorerFilesSplatRouteImport.update({
    id: '/files/$',
    path: '/files/$',
    getParentRoute: () => PProjectIdBranchExplorerRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/org': typeof OrgRoute
  '/sign-in': typeof SignInRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/p/$projectId': typeof PProjectIdRouteWithChildren
  '/prototypes/agent-first': typeof PrototypesAgentFirstRoute
  '/prototypes/clash-meeting': typeof PrototypesClashMeetingRoute
  '/prototypes/evolution': typeof PrototypesEvolutionRoute
  '/prototypes/manager': typeof PrototypesManagerRoute
  '/prototypes/pricing': typeof PrototypesPricingRoute
  '/prototypes/quote': typeof PrototypesQuoteRoute
  '/prototypes/understudy': typeof PrototypesUnderstudyRoute
  '/prototypes/': typeof PrototypesIndexRoute
  '/traces/': typeof TracesIndexRoute
  '/p/$projectId/$branch': typeof PProjectIdBranchRouteWithChildren
  '/p/$projectId/workshop': typeof PProjectIdWorkshopRoute
  '/p/$projectId/': typeof PProjectIdIndexRoute
  '/traces/$traceId/': typeof TracesTraceIdIndexRoute
  '/p/$projectId/$branch/explorer': typeof PProjectIdBranchExplorerRouteWithChildren
  '/p/$projectId/$branch/': typeof PProjectIdBranchIndexRoute
  '/traces/chats/$chatId/': typeof TracesChatsChatIdIndexRoute
  '/p/$projectId/$branch/$scope/$appId': typeof PProjectIdBranchScopeAppIdRoute
  '/p/$projectId/$branch/workbench/$view': typeof PProjectIdBranchWorkbenchViewRoute
  '/p/$projectId/$branch/explorer/files/$': typeof PProjectIdBranchExplorerFilesSplatRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/org': typeof OrgRoute
  '/sign-in': typeof SignInRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/prototypes/agent-first': typeof PrototypesAgentFirstRoute
  '/prototypes/clash-meeting': typeof PrototypesClashMeetingRoute
  '/prototypes/evolution': typeof PrototypesEvolutionRoute
  '/prototypes/manager': typeof PrototypesManagerRoute
  '/prototypes/pricing': typeof PrototypesPricingRoute
  '/prototypes/quote': typeof PrototypesQuoteRoute
  '/prototypes/understudy': typeof PrototypesUnderstudyRoute
  '/prototypes': typeof PrototypesIndexRoute
  '/traces': typeof TracesIndexRoute
  '/p/$projectId/workshop': typeof PProjectIdWorkshopRoute
  '/p/$projectId': typeof PProjectIdIndexRoute
  '/traces/$traceId': typeof TracesTraceIdIndexRoute
  '/p/$projectId/$branch/explorer': typeof PProjectIdBranchExplorerRouteWithChildren
  '/p/$projectId/$branch': typeof PProjectIdBranchIndexRoute
  '/traces/chats/$chatId': typeof TracesChatsChatIdIndexRoute
  '/p/$projectId/$branch/$scope/$appId': typeof PProjectIdBranchScopeAppIdRoute
  '/p/$projectId/$branch/workbench/$view': typeof PProjectIdBranchWorkbenchViewRoute
  '/p/$projectId/$branch/explorer/files/$': typeof PProjectIdBranchExplorerFilesSplatRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/org': typeof OrgRoute
  '/sign-in': typeof SignInRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/p/$projectId': typeof PProjectIdRouteWithChildren
  '/prototypes/agent-first': typeof PrototypesAgentFirstRoute
  '/prototypes/clash-meeting': typeof PrototypesClashMeetingRoute
  '/prototypes/evolution': typeof PrototypesEvolutionRoute
  '/prototypes/manager': typeof PrototypesManagerRoute
  '/prototypes/pricing': typeof PrototypesPricingRoute
  '/prototypes/quote': typeof PrototypesQuoteRoute
  '/prototypes/understudy': typeof PrototypesUnderstudyRoute
  '/prototypes/': typeof PrototypesIndexRoute
  '/traces/': typeof TracesIndexRoute
  '/p/$projectId/$branch': typeof PProjectIdBranchRouteWithChildren
  '/p/$projectId/workshop': typeof PProjectIdWorkshopRoute
  '/p/$projectId/': typeof PProjectIdIndexRoute
  '/traces/$traceId/': typeof TracesTraceIdIndexRoute
  '/p/$projectId/$branch/explorer': typeof PProjectIdBranchExplorerRouteWithChildren
  '/p/$projectId/$branch/': typeof PProjectIdBranchIndexRoute
  '/traces/chats/$chatId/': typeof TracesChatsChatIdIndexRoute
  '/p/$projectId/$branch/$scope/$appId': typeof PProjectIdBranchScopeAppIdRoute
  '/p/$projectId/$branch/workbench/$view': typeof PProjectIdBranchWorkbenchViewRoute
  '/p/$projectId/$branch/explorer/files/$': typeof PProjectIdBranchExplorerFilesSplatRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/org'
    | '/sign-in'
    | '/invite/$invitationId'
    | '/p/$projectId'
    | '/prototypes/agent-first'
    | '/prototypes/clash-meeting'
    | '/prototypes/evolution'
    | '/prototypes/manager'
    | '/prototypes/pricing'
    | '/prototypes/quote'
    | '/prototypes/understudy'
    | '/prototypes/'
    | '/traces/'
    | '/p/$projectId/$branch'
    | '/p/$projectId/workshop'
    | '/p/$projectId/'
    | '/traces/$traceId/'
    | '/p/$projectId/$branch/explorer'
    | '/p/$projectId/$branch/'
    | '/traces/chats/$chatId/'
    | '/p/$projectId/$branch/$scope/$appId'
    | '/p/$projectId/$branch/workbench/$view'
    | '/p/$projectId/$branch/explorer/files/$'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/org'
    | '/sign-in'
    | '/invite/$invitationId'
    | '/prototypes/agent-first'
    | '/prototypes/clash-meeting'
    | '/prototypes/evolution'
    | '/prototypes/manager'
    | '/prototypes/pricing'
    | '/prototypes/quote'
    | '/prototypes/understudy'
    | '/prototypes'
    | '/traces'
    | '/p/$projectId/workshop'
    | '/p/$projectId'
    | '/traces/$traceId'
    | '/p/$projectId/$branch/explorer'
    | '/p/$projectId/$branch'
    | '/traces/chats/$chatId'
    | '/p/$projectId/$branch/$scope/$appId'
    | '/p/$projectId/$branch/workbench/$view'
    | '/p/$projectId/$branch/explorer/files/$'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/org'
    | '/sign-in'
    | '/invite/$invitationId'
    | '/p/$projectId'
    | '/prototypes/agent-first'
    | '/prototypes/clash-meeting'
    | '/prototypes/evolution'
    | '/prototypes/manager'
    | '/prototypes/pricing'
    | '/prototypes/quote'
    | '/prototypes/understudy'
    | '/prototypes/'
    | '/traces/'
    | '/p/$projectId/$branch'
    | '/p/$projectId/workshop'
    | '/p/$projectId/'
    | '/traces/$traceId/'
    | '/p/$projectId/$branch/explorer'
    | '/p/$projectId/$branch/'
    | '/traces/chats/$chatId/'
    | '/p/$projectId/$branch/$scope/$appId'
    | '/p/$projectId/$branch/workbench/$view'
    | '/p/$projectId/$branch/explorer/files/$'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  OrgRoute: typeof OrgRoute
  SignInRoute: typeof SignInRoute
  InviteInvitationIdRoute: typeof InviteInvitationIdRoute
  PProjectIdRoute: typeof PProjectIdRouteWithChildren
  PrototypesAgentFirstRoute: typeof PrototypesAgentFirstRoute
  PrototypesClashMeetingRoute: typeof PrototypesClashMeetingRoute
  PrototypesEvolutionRoute: typeof PrototypesEvolutionRoute
  PrototypesManagerRoute: typeof PrototypesManagerRoute
  PrototypesPricingRoute: typeof PrototypesPricingRoute
  PrototypesQuoteRoute: typeof PrototypesQuoteRoute
  PrototypesUnderstudyRoute: typeof PrototypesUnderstudyRoute
  PrototypesIndexRoute: typeof PrototypesIndexRoute
  TracesIndexRoute: typeof TracesIndexRoute
  TracesTraceIdIndexRoute: typeof TracesTraceIdIndexRoute
  TracesChatsChatIdIndexRoute: typeof TracesChatsChatIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org': {
      id: '/org'
      path: '/org'
      fullPath: '/org'
      preLoaderRoute: typeof OrgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$invitationId': {
      id: '/invite/$invitationId'
      path: '/invite/$invitationId'
      fullPath: '/invite/$invitationId'
      preLoaderRoute: typeof InviteInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$projectId': {
      id: '/p/$projectId'
      path: '/p/$projectId'
      fullPath: '/p/$projectId'
      preLoaderRoute: typeof PProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/': {
      id: '/prototypes/'
      path: '/prototypes'
      fullPath: '/prototypes/'
      preLoaderRoute: typeof PrototypesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/agent-first': {
      id: '/prototypes/agent-first'
      path: '/prototypes/agent-first'
      fullPath: '/prototypes/agent-first'
      preLoaderRoute: typeof PrototypesAgentFirstRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/clash-meeting': {
      id: '/prototypes/clash-meeting'
      path: '/prototypes/clash-meeting'
      fullPath: '/prototypes/clash-meeting'
      preLoaderRoute: typeof PrototypesClashMeetingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/evolution': {
      id: '/prototypes/evolution'
      path: '/prototypes/evolution'
      fullPath: '/prototypes/evolution'
      preLoaderRoute: typeof PrototypesEvolutionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/manager': {
      id: '/prototypes/manager'
      path: '/prototypes/manager'
      fullPath: '/prototypes/manager'
      preLoaderRoute: typeof PrototypesManagerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/pricing': {
      id: '/prototypes/pricing'
      path: '/prototypes/pricing'
      fullPath: '/prototypes/pricing'
      preLoaderRoute: typeof PrototypesPricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/quote': {
      id: '/prototypes/quote'
      path: '/prototypes/quote'
      fullPath: '/prototypes/quote'
      preLoaderRoute: typeof PrototypesQuoteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/understudy': {
      id: '/prototypes/understudy'
      path: '/prototypes/understudy'
      fullPath: '/prototypes/understudy'
      preLoaderRoute: typeof PrototypesUnderstudyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/traces/': {
      id: '/traces/'
      path: '/traces'
      fullPath: '/traces/'
      preLoaderRoute: typeof TracesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$projectId/': {
      id: '/p/$projectId/'
      path: '/'
      fullPath: '/p/$projectId/'
      preLoaderRoute: typeof PProjectIdIndexRouteImport
      parentRoute: typeof PProjectIdRoute
    }
    '/p/$projectId/$branch': {
      id: '/p/$projectId/$branch'
      path: '/$branch'
      fullPath: '/p/$projectId/$branch'
      preLoaderRoute: typeof PProjectIdBranchRouteImport
      parentRoute: typeof PProjectIdRoute
    }
    '/p/$projectId/workshop': {
      id: '/p/$projectId/workshop'
      path: '/workshop'
      fullPath: '/p/$projectId/workshop'
      preLoaderRoute: typeof PProjectIdWorkshopRouteImport
      parentRoute: typeof PProjectIdRoute
    }
    '/traces/$traceId/': {
      id: '/traces/$traceId/'
      path: '/traces/$traceId'
      fullPath: '/traces/$traceId/'
      preLoaderRoute: typeof TracesTraceIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$projectId/$branch/': {
      id: '/p/$projectId/$branch/'
      path: '/'
      fullPath: '/p/$projectId/$branch/'
      preLoaderRoute: typeof PProjectIdBranchIndexRouteImport
      parentRoute: typeof PProjectIdBranchRoute
    }
    '/p/$projectId/$branch/explorer': {
      id: '/p/$projectId/$branch/explorer'
      path: '/explorer'
      fullPath: '/p/$projectId/$branch/explorer'
      preLoaderRoute: typeof PProjectIdBranchExplorerRouteImport
      parentRoute: typeof PProjectIdBranchRoute
    }
    '/traces/chats/$chatId/': {
      id: '/traces/chats/$chatId/'
      path: '/traces/chats/$chatId'
      fullPath: '/traces/chats/$chatId/'
      preLoaderRoute: typeof TracesChatsChatIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$projectId/$branch/$scope/$appId': {
      id: '/p/$projectId/$branch/$scope/$appId'
      path: '/$scope/$appId'
      fullPath: '/p/$projectId/$branch/$scope/$appId'
      preLoaderRoute: typeof PProjectIdBranchScopeAppIdRouteImport
      parentRoute: typeof PProjectIdBranchRoute
    }
    '/p/$projectId/$branch/workbench/$view': {
      id: '/p/$projectId/$branch/workbench/$view'
      path: '/workbench/$view'
      fullPath: '/p/$projectId/$branch/workbench/$view'
      preLoaderRoute: typeof PProjectIdBranchWorkbenchViewRouteImport
      parentRoute: typeof PProjectIdBranchRoute
    }
    '/p/$projectId/$branch/explorer/files/$': {
      id: '/p/$projectId/$branch/explorer/files/$'
      path: '/files/$'
      fullPath: '/p/$projectId/$branch/explorer/files/$'
      preLoaderRoute: typeof PProjectIdBranchExplorerFilesSplatRouteImport
      parentRoute: typeof PProjectIdBranchExplorerRoute
    }
  }
}

interface PProjectIdBranchExplorerRouteChildren {
  PProjectIdBranchExplorerFilesSplatRoute: typeof PProjectIdBranchExplorerFilesSplatRoute
}

const PProjectIdBranchExplorerRouteChildren: PProjectIdBranchExplorerRouteChildren =
  {
    PProjectIdBranchExplorerFilesSplatRoute:
      PProjectIdBranchExplorerFilesSplatRoute,
  }

const PProjectIdBranchExplorerRouteWithChildren =
  PProjectIdBranchExplorerRoute._addFileChildren(
    PProjectIdBranchExplorerRouteChildren,
  )

interface PProjectIdBranchRouteChildren {
  PProjectIdBranchExplorerRoute: typeof PProjectIdBranchExplorerRouteWithChildren
  PProjectIdBranchIndexRoute: typeof PProjectIdBranchIndexRoute
  PProjectIdBranchScopeAppIdRoute: typeof PProjectIdBranchScopeAppIdRoute
  PProjectIdBranchWorkbenchViewRoute: typeof PProjectIdBranchWorkbenchViewRoute
}

const PProjectIdBranchRouteChildren: PProjectIdBranchRouteChildren = {
  PProjectIdBranchExplorerRoute: PProjectIdBranchExplorerRouteWithChildren,
  PProjectIdBranchIndexRoute: PProjectIdBranchIndexRoute,
  PProjectIdBranchScopeAppIdRoute: PProjectIdBranchScopeAppIdRoute,
  PProjectIdBranchWorkbenchViewRoute: PProjectIdBranchWorkbenchViewRoute,
}

const PProjectIdBranchRouteWithChildren =
  PProjectIdBranchRoute._addFileChildren(PProjectIdBranchRouteChildren)

interface PProjectIdRouteChildren {
  PProjectIdBranchRoute: typeof PProjectIdBranchRouteWithChildren
  PProjectIdWorkshopRoute: typeof PProjectIdWorkshopRoute
  PProjectIdIndexRoute: typeof PProjectIdIndexRoute
}

const PProjectIdRouteChildren: PProjectIdRouteChildren = {
  PProjectIdBranchRoute: PProjectIdBranchRouteWithChildren,
  PProjectIdWorkshopRoute: PProjectIdWorkshopRoute,
  PProjectIdIndexRoute: PProjectIdIndexRoute,
}

const PProjectIdRouteWithChildren = PProjectIdRoute._addFileChildren(
  PProjectIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  OrgRoute: OrgRoute,
  SignInRoute: SignInRoute,
  InviteInvitationIdRoute: InviteInvitationIdRoute,
  PProjectIdRoute: PProjectIdRouteWithChildren,
  PrototypesAgentFirstRoute: PrototypesAgentFirstRoute,
  PrototypesClashMeetingRoute: PrototypesClashMeetingRoute,
  PrototypesEvolutionRoute: PrototypesEvolutionRoute,
  PrototypesManagerRoute: PrototypesManagerRoute,
  PrototypesPricingRoute: PrototypesPricingRoute,
  PrototypesQuoteRoute: PrototypesQuoteRoute,
  PrototypesUnderstudyRoute: PrototypesUnderstudyRoute,
  PrototypesIndexRoute: PrototypesIndexRoute,
  TracesIndexRoute: TracesIndexRoute,
  TracesTraceIdIndexRoute: TracesTraceIdIndexRoute,
  TracesChatsChatIdIndexRoute: TracesChatsChatIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
